<template>
	<div>
		<div>
			<div class="row">
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<!--
						<i @click="$refs.createAgreement.open()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
						-->
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/requests'">
							<h3 class="box-title">SOLICITUDES</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i class="fa fa fa-info-circle fa-fw text-info"></i></li>
							<li class="text-right"><span class="counter">{{ requests }}</span></li>
						</ul>
					</div>
				</div>
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<router-link to="management/customers/create" class="pull-right link-blue btn btn-default btn-circle">
							<i class="fa fa-plus"></i>
						</router-link>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers'" >
							<h3 class="box-title">CLIENTES</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i class="icon-people text-info"></i></li>
							<li class="text-right"><span class="counter">{{ customers }}</span></li>
						</ul>
					</div>
				</div>
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<i @click="createBudget()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
						<loading :active="loadingBudget">
							<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
						</loading>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/budgets'">
							<h3 class="box-title">PRESUPUESTOS</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i class="fa fa-clipboard fa-fw text-info"></i></li>
							<li class="text-right"><span class="counter">{{ budgets }}</span></li>
						</ul>
					</div>
				</div>
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<i @click="$refs.createOrder.open()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders'">
							<h3 class="box-title">PEDIDOS</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i aria-hidden="true" class="fa fa-file-text fa-fw text-info"></i></li>
							<li class="text-right"><span class="counter">{{ orders }}</span></li>
						</ul>
					</div>
				</div>
				<template v-if="!user.hasRole('staff')">
					<div class="col-lg-3 col-sm-6 col-xs-12">
						<div class="white-box">
							<i @click="$refs.createInvoice.open()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
							<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices'">
								<h3 class="box-title">FACTURAS</h3>
							</router-link>
							<ul class="list-inline two-part">
								<li><i class="fa fa-clipboard fa-fw text-info"></i></li>
								<li class="text-right"><span class="counter">{{ invoices }}</span></li>
							</ul>
						</div>
					</div>
				</template>
				
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<i @click="$refs.createProject.open()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects'">
							<h3 class="box-title">PROYECTOS</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i class="ti-folder fa-fw text-info"></i></li>
							<li class="text-right"><span class="">{{ projects }}</span></li>
						</ul>
					</div>
				</div>
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<router-link to="management/products/create" class="pull-right link-blue btn btn-default btn-circle">
							<i class="fa fa-plus"></i>
						</router-link>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products'">
							<h3 class="box-title">PRODUCTOS</h3>
						</router-link>
						<ul class="list-inline two-part">
							<li><i class="fa fa-cube fa-fw text-info"></i></li>
							<li class="text-right"><span class="counter">{{ products }}</span></li>
						</ul>
					</div>
				</div>
				<div class="col-lg-3 col-sm-6 col-xs-12">
					<div class="white-box">
						<i @click="$refs.createAgreement.open()" class="fa fa-plus pull-right link link-blue btn btn-default btn-circle"></i>
						<h3 class="box-title">CONTRATOS</h3>
						<ul class="list-inline two-part">
							<li><i class="fa fa-handshake-o fa-fw text-info"></i></li>
							<li class="text-right"><span class="counter">{{ agreements }}</span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
				<new-customers-per-day
					ref="newCustomersPerDay"
					:user="user"
					:isAuth="isAuth">
				</new-customers-per-day>
			</div>

			<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
				<updated-budgets-per-day
					ref="newBudgetsPerDay"
					:user="user"
					:isAuth="isAuth">
				</updated-budgets-per-day>
			</div>
			
			<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
				<new-projects-per-month
					ref="newProjectsPerMonth"
					:user="user"
					:isAuth="isAuth">
				</new-projects-per-month>
			</div>
		</div>

		<create-order
			@reload="reload"
			ref="createOrder"
			:user="user"
			:isAuth="isAuth">
		</create-order>

		<create-invoice
			@reload="reload"
			ref="createInvoice"
			:user="user"
			:isAuth="isAuth">
		</create-invoice>

		<create-project
			@reload="reload"
			@createTask="openTaskCreate"
			ref="createProject"
			:user="user"
			:isAuth="isAuth">
		</create-project>

		<task-create
			ref="taskCreate"
			@openCreateSchedule="openCreateSchedule"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			ref="schedulecreate"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>

		<agreement-create
			ref="createAgreement"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</agreement-create>

		<fab
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	//import newCustomersPerMonth from '../views/charts/newCustomersPerMonth.vue'
	import newCustomersPerDay from '../views/charts/newCustomersPerDay.vue'
	//import newBudgetsPerDay from '../views/charts/newBudgetsPerDay.vue'
	import updatedBudgetsPerDay from '../views/charts/updatedBudgetsPerDay.vue'
	import newProjectsPerMonth from './../../../projects/dashboard/views/charts/newProjectsPerMonth.vue'
	import statusTasks from './../../../projects/dashboard/views/charts/statusTasks.vue'
	import VueElementLoading from 'vue-element-loading'

	import CreateOrder from '@/components/management/orders/views/Create.vue'
	import CreateInvoice from '@/components/management/invoices/views/Create.vue'

	import CreateProject from '@/components/projects/projects/views/Create.vue'
	import TaskCreate from '@/components/projects/tasks/views/Create.vue'
	import ScheduleCreate from '@/components/projects/schedules/views/Create.vue'
	import AgreementCreate from '@/components/agreements/views/Create.vue'

	import Fab from '../views/Fab'

	export default {
		props: ['user', 'isAuth'],
		components: {
			//'new-customers-per-month': newCustomersPerMonth,
			'new-customers-per-day': newCustomersPerDay,
			//'new-budgets-per-day': newBudgetsPerDay,
			'updated-budgets-per-day': updatedBudgetsPerDay,
			'new-projects-per-month': newProjectsPerMonth,
			'status-tasks': statusTasks,

			'loading': VueElementLoading,

			'create-order': CreateOrder,
			'create-invoice': CreateInvoice,

			'create-project': CreateProject,
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
			'agreement-create': AgreementCreate,

			'fab': Fab,
		},
		data () {
			return {
				customers: 0,
				budgets: 0,
				orders: 0,
				invoices: 0,
				projects: 0,
				products: 0,
				agreements: 0,
				requests: 0,
				tasks: 0,

				loadingBudget: false,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				var that = this
				this.getResume()
			},
			reload() {
				this.getResume()
			},
			getResume() {
				this.$http.get('admin/resume')
				.then(response => {
					this.customers = response.body.customers
					this.budgets = response.body.budgets
					this.orders = response.body.orders
					this.invoices = response.body.invoices
					this.projects = response.body.projects
					this.products = response.body.products
					this.agreements = response.body.agreements
					this.requests = response.body.requests
				})
			},
			editOrContinue(response, link) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push(link)
				}).catch()
			},
			createBudget () {
				this.loadingBudget = true
				this.$http.post('admin/management/budgets')
				.then(response => {
					this.reload()
					this.loadingBudget = false
					var link = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit'
					this.editOrContinue(response, link)
				}).catch(function(response) {
					console.log(response)
					this.reload()
					this.loadingBudget = false
				})
			},
			//--
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/dashboard/layout/Dashboard.vue